var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPairing = function SvgIconPairing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.334a5.5 5.5 0 0 1 7.102-5.263.5.5 0 0 0 .29-.957 6.5 6.5 0 1 0 3.443 2.507.5.5 0 0 0-.82.572A5.503 5.503 0 0 1 8.5 17.834a5.5 5.5 0 0 1-5.5-5.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.897 7.071a5.5 5.5 0 1 1-.023 10.519.5.5 0 1 0-.295.955 6.5 6.5 0 1 0-3.415-2.5.5.5 0 1 0 .82-.571 5.503 5.503 0 0 1 2.913-8.403"
  })));
};
export default SvgIconPairing;